import React, { memo, useCallback, useRef } from 'react';
import { isThisMonth } from 'date-fns';
import { MonthsCellStyled } from './MonthCellStyled';
export const MonthCell = memo(({ year, monthIndex, monthLabel, goToMonth, toggleDropdown }) => {
    const date = useRef(new Date(year, monthIndex));
    const handleOnClick = useCallback(() => {
        goToMonth(date.current);
        toggleDropdown();
    }, [goToMonth, toggleDropdown]);
    const isCurrentMonth = isThisMonth(date.current);
    return (React.createElement(MonthsCellStyled, { onClick: handleOnClick, isCurrentMonth: isCurrentMonth }, monthLabel));
});
MonthCell.displayName = 'MonthCell';
